module.exports = __webpack_public_path__ + "static/media/artunity-mockup-2.f6b63d8a.jpg";